<template>
  <div id="app" ref="main">
    <Header></Header>
    <router-view/>
    <Footer></Footer>
    <!-- <GoTop></GoTop> -->
  </div>
</template>

<script>
export default {
  name: 'App',

watch:{

    $router(){
    let main=this.$refs.main
     console.log(main,"**********")
    main.scrollTo(0,0)
    }
}, 

}
</script>

<style>
a:hover{text-decoration:none}
</style>



// WEBPACK FOOTER //
// src/App.vue